export const MSG_CHAVE_PIX_COPIADA = "Chave PIX copiada!";

